module.exports = __webpack_public_path__ + "img/aave.0915fe5a.svg";